import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_suggested_wraps.name_en"),
        name: data?.name,
      },
      {
        label: t("wrappers_suggested_wraps.name_ar"),
        name: data?.name,
      },
      {
        label: t("wrappers_suggested_wraps.wrappable_type"),
        name: data?.wrappable_type,
      },
      {
        label: t("wrappers_suggested_wraps.wrap_variant"),
        name: data?.wrap_variant?.name,
      },
      {
        label: t("wrappers_suggested_wraps.ribbon_color"),
        name: data?.ribbon_color?.name,
      },
      {
        label: t("wrappers_suggested_wraps.wrap_extras"),
        name: data?.wrap_extras?.map((wrap) => wrap.name).join(", "),
      },
      {
        label: t("wrappers_suggested_wraps.theme_description_en"),
        name: data?.localized_data?.en?.description,
      },
      {
        label: t("wrappers_suggested_wraps.theme_description_ar"),
        name: data?.localized_data?.ar?.description,
      },
      {
        label: t("wrappers_suggested_wraps.show_in_packaging"),
        name:
          data?.show_in_packaging === true
            ? t("common.yes")
            : data?.show_in_packaging === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_suggested_wraps.is_active"),
        name:
          data?.is_active === true
            ? t("common.yes")
            : data?.is_active === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_suggested_wraps.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons.priceIcon,
    details: [
      {
        label: t("wrappers_suggested_wraps.price"),
        name: data?.cost + " " + data?.wrap_variant?.currency?.name,
      },
      {
        label: t("wrappers_suggested_wraps.price_after_discount"),
        name:
          data?.cost_after_discount + " " + data?.wrap_variant?.currency?.name,
      },
    ],
  },
];
